import { useParams } from "react-router-dom";

export default function Participant() {
  const params = useParams();
  return <div>Participant: {params.participantId}</div>;
}
